var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item-overview"},_vm._l((_vm.itemCountOverviewList),function(infoBadgData){return _c('InfoBadge',{key:infoBadgData.color,staticClass:"item-overview__badge",class:{
      'item-overview__badge--opaque': infoBadgData.type === _vm.overViewType.FILTERED && !_vm.isViewFiltered
    },attrs:{"highlighted":infoBadgData.type === _vm.overViewType.FILTERED && _vm.isViewFiltered,"info-badge-data":infoBadgData,"show-size":_vm.showSizes}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }